
const getValueByKey = key => {
  const cookieMap = document.cookie.split('; ').reduce((accu, item) => {
    const [k, v] = item.split('=');
    accu[k] = v;
    return accu;
  },{});
  return cookieMap[key];
  // return '';
}

const clearValueByKey = (key) => {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    const cval=getValueByKey(key);
    if(cval!=null)
    document.cookie= key + "="+cval+";domain=.icourse163.org;expires="+exp.toGMTString();
}

export default {
  getValueByKey,
  clearValueByKey,
};
